import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminEditEmailTemplatePage = React.lazy(() => import(/* webpackChunkName: "AdminEditEmailTemplate" */ './Page'));
export const AdminEditEmailTemplate = () => (React.createElement(Page, { title: "Edit Email Template" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminEditEmailTemplatePage, null)))));
